import { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/lab/Alert';
import {marginBottomForBreadCrumb } from '../../config/styles';
import TabPanel from './TabPanel';
import BreadCrumb from '../atoms/breadcrumb/';
import { useDispatch, useSelector } from 'react-redux';
import { getTemplateClusterlets } from '../../store/constructs/templated_clusterlet/selectors';
import NoUserTriggerAlert from '../molecules/user_triggers/NoUserTriggerAlert';
import { getTabOnFocus } from '../../store/global/selectors';
import NoRoutingRuleAlert from '../molecules/routing_rules/NoRoutingRuleAlert';

import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { StyledTableCell } from '../atoms/table/tableStyles';

const shortUUiD = require("short-uuid");


export default function TemplateDelegate({ element }) {

    console.log('element--->', element)

    const dispatch = useDispatch();
    const defaultAction = { action: '', id: null, item: null };
    const [value, setValue] = useState(0);
    const [action, setAction] = useState(defaultAction);
    const templates = useSelector(getTemplateClusterlets);
    const tabOnFocus = useSelector(getTabOnFocus);

    const [uTrigers, setUtriggers] = useState([]);
    const [rrDefs, setRrdefs] = useState([]);
    const selectedTemplate = templates.find(template => template.id == element?.templateId)
    const [openTab, setOpenTab] = useState(0);
    const [breadCrumbItem, setBreadCrumbItem] = useState([])



    const detailsBC = [
        { label: 'Template Delegate', url: null },
        { label: element.name, url: null }
    ];

    const userTriggerItem = [
        { label: 'User Triggers', url: null }
    ]

    const rrdefItem = [
        { label: 'Routing Rules', url: null }
    ]

    const formatData = (data) => {
        const formattedData = [];

        for (const [key, value] of Object.entries(data)) {
            const obj = {
                id: shortUUiD.generate(),
                type: 22,
                attributes: {},
                extensions: []
            }

            // for (const [key, value] of Object.entries(data?.args)) {

            //     obj.attributes[key] = value;
            // }


            formattedData.push(obj)
        }

        return formattedData
    }


    useEffect(() => {

        const metaJson = selectedTemplate.metajson;

        const userTriggers = formatData(metaJson?.user_triggers);
        setUtriggers(userTriggers)

        console.log('userTriggers--->', userTriggers)


    }, [])

    useEffect(() => {
        setOpenTab(tabOnFocus);
        setAction({})
        setBreadCrumbItem([])
    }, [tabOnFocus])

    const onCompletion = () => {


    }

    const onClose = () => {
        setAction(defaultAction)
    }




    return (
        <>
            <AppBar position="static">
                <Tabs value={value} onChange={(e, v) => { setValue(v); setAction({}) }} aria-label="simple tabs example">
                    <Tab label="Details" />
                    <Tab label="User Triggers" />
                    <Tab label="Routing rules" />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0} >
                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>

                    {/* <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Delete Template" arrow>
                            <IconButton onClick={e => setAction({ action: 'delete_template' })}><DeleteIcon color="secondary" /></IconButton>
                        </Tooltip>
                    </Grid> */}

                </Grid>
                <Divider style={marginBottomForBreadCrumb} />

                <Grid container direction={"row"} spacing={2}>
                    {/* {action.action === '' && <Grid item xs={12} alignItems='center'>
                        <Typography variant='subtitle1'> {`Template Delegate: ${element.name}`}</Typography>

                    </Grid>} */}
                    <Grid item xs={12} alignItems='center'>
                        <Alert severity="info">No configurations availabe</Alert>
                    </Grid>
                </Grid>

                {/* {action.action === 'delete_template' && <DeleteTemplateAlert id={element.id} onClose={onClose} onCompletion={onCompletion} />} */}

            </TabPanel>
            <TabPanel value={value} index={1}>
                <Grid container direction="row" >
                    <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-start" }}>
                        <BreadCrumb items={[...detailsBC, ...userTriggerItem,]} />
                    </Grid>

                </Grid>
                <Divider style={marginBottomForBreadCrumb} />
                {Object.keys(action).length === 0 && uTrigers.length === 0 && <NoUserTriggerAlert />}

                {/* {Object.keys(action).length === 0 && uTrigers.length > 0 && <ListItems list={uTrigers} />} */}


            </TabPanel>
            <TabPanel value={value} index={2}>
                <Grid container direction="row" >
                    <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-start" }}>
                        <BreadCrumb items={[...detailsBC, ...rrdefItem,]} />
                    </Grid>

                </Grid>
                <Divider style={marginBottomForBreadCrumb} />
                {Object.keys(action).length === 0 && rrDefs.length === 0 && <NoRoutingRuleAlert />}

                {/* {Object.keys(action).length === 0 && rrDefs.length > 0 && <p>Hi</p>} */}


            </TabPanel>
        </>
    )
}



function ListItems(props) {
    return (
        <TableContainer component={Paper} >
            <Table aria-label="customized table" >
                <TableHead>
                    <TableRow>
                        <StyledTableCell align='center'>#</StyledTableCell>
                        {/* <StyledTableCell align='center'>Name</StyledTableCell> */}
                        <StyledTableCell align='center'>Description</StyledTableCell>
                        <StyledTableCell align='right' >Actions</StyledTableCell>
                    </TableRow>
                </TableHead>
            </Table>

        </TableContainer>
    )
}
